import React from "react";
import { Container } from "@mui/material";
import NavBar from "../Nav_Components/NavBar";
import Form from "../Form_Component/Form";
import Login from "../Login_Component/Login";
import { Route, Routes } from "react-router";
import NotFound from "../../utils/NotFound";
import ProtectedRoute from "../../utils/ProtectedRoute";
import Template from "../../Template/Template";

function Layout() {
  return (
    <>
      <NavBar />
      <Template>
      <Container>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/entry_form" element={<Form />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
      </Template>
    </>
  );
}

export default Layout;
